import React from 'react';
import { useSelectWeatherConditionFieldQuery } from 'generated/graphql';

export type IData = {
  id: string;
  name: string;
  displayName: string;
};

export function useQuery() {
  const tuple = useSelectWeatherConditionFieldQuery();

  return React.useMemo(
    () => {
      const data: IData[] = tuple.data?.weatherConditions?.map((node) => ({
        id: node?.id ?? '',
        name: node?.name ?? '',
        displayName: node?.displayName ?? ''
      }
      )) ?? [];

      return {
        ...tuple,
        data
      };
    }
    , [tuple]
  );
}
